export const getResultRatingByCode = (state, code) => {
    const resultRatings = {};
    const { entries }   = state.resultRating.resultRatings;
    Object.keys(entries).forEach(id => {
        resultRatings[entries[id].code] = entries[id];
    });

    return resultRatings[code] || null;
}
